import React from 'react';
import ThreeDimensionalIcon from './three-dimensional';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ThreeSixtyIcon(props) {
  return ___EmotionJSX(ThreeDimensionalIcon, props);
}